<template>

<core-modal v-on:close="onClose" :nopadding="true" :noheader="true" :is-large="true" icon="caret-left">

	<template v-slot:head>

	</template>

	<template v-slot:default>

		<div class="notification-image" :style="{backgroundImage: 'url(' + data.notification.image + ')'}" v-if="data.notification.image" />
		<div class="notification-icon" :data-type="data.notification.type" v-if="!data.notification.image">

			<i :class="icons[data.notification.type]" />

		</div>

		<div class="notification-title">

			{{ data.notification.name }}
			<small>{{ data.notification.date | formatDate('MMMM Do YYYY') }}</small>

		</div>

		<div class="notification-tags" v-if="isUpdate">
				
			<div class="notification-tags-item is-additions" v-if="data.notification.data.additions">Additions <span>{{ data.notification.data.additions }}</span></div>
			<div class="notification-tags-item is-fixes" v-if="data.notification.data.fixes">Fixes <span>{{ data.notification.data.fixes }}</span></div>

		</div>

		<div class="notification-content" v-html="data.notification.content" />

        <core-button :href="data.notification.url" target="_blank" theme="yellow" class="notification-button" v-if="data.notification.url">Read more</core-button>

	</template>

</core-modal>

</template>

<script>

export default {

    props: ['data'],

	data: function() {

		return {
			icons: {
				1: 'fa-solid fa-rocket-launch',
				2: 'fa-solid fa-rotate',
				3: 'fa-solid fa-check-to-slot',
				4: 'fa-solid fa-flask',
				5: 'fa-solid fa-message-code',
				6: 'fa-brands fa-patreon'
			}
		}

	},

    computed: {
    
        isUpdate: function() {
        
            return this.data.notification.type === 1
        
        }

    },

	methods: {

		onClose: function() {

			this.$emit('close')
            this.$pubsub.$emit('open.modal', 'appUpdates')

		}

	}

}

</script>

<style scoped>

.notification-title {
	color: #333;
	font-size: 20px;
	font-weight: 500;
    padding: 20px 15px 0px 15px;
}

.notification-title small {
	font-size: 16px;
	font-weight: 300;
	display: block;
	margin-top: 4px;
}

.notification-tags {
    display: flex;
	margin-top: 2px;
    padding: 20px 15px 0px 15px;
}

.notification-tags-item {
	border-radius: 4px;
	font-size: 12px;
	font-weight: 400;
	color: #fff;
	margin-right: 5px;
	padding: 3px 5px;
}

.notification-tags-item span {
	padding-left: 5px;
	margin-left: 3px;
	border-left: 1px solid rgba(255, 255, 255, 0.5);
}

.notification-tags-item.is-additions {
	background-color: #40b95a;
}

.notification-tags-item.is-fixes {
	background-color: #42a4fa;
}

.notification-image {
    background-position: 50% 0%;
    background-size: cover;
    background-color: #eee;
    background-repeat: no-repeat;
    border-bottom: 1px solid #eee;
    height: 320px;
}

.notification-icon {
    height: 320px;
	color: #fff;
    line-height: 320px;
    font-size: 128px;
	text-align: center;
	width: 100%;
}

.is-mobile .notification-icon,
.is-mobile .notification-image {
    height: 160px;
    line-height: 160px;
    font-size: 64px;
}

.notification-content {
    color: #333;
    font-size: 16px;
    line-height: 20px;
    padding: 20px 15px;
}

.notification-content >>> p {
    margin-bottom: 20px;
}

.notification-content >>> p:last-child {
    margin-bottom: 0px;
}

.notification-button {
    width: calc(100% - 30px);
    margin: 0px 15px;
	font-size: 16px!important;
}

.notification-icon[data-type="1"] {
	background-color: #f6c86c;
	color: #012b39;
}

.notification-icon[data-type="3"] {
	background-color: #43A047;
}

.notification-icon[data-type="4"] {
	background-color: #4881bb;
}

.notification-icon[data-type="5"]  {
	background-color: #7C4DFF;
}

.notification-icon[data-type="6"]  {
	background-color: #1A1F36;
}

</style>